import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as componentActions from '../../actions';
import ConventionPage from '../../components/ConventionPage';

export const LANGUAGES = ['en', 'fr'];

export const pageLanguage = (language) => (LANGUAGES.indexOf(language) !== -1 ? language : 'en');

// Route of the acknowledgement link sent by mail (/ack-of-receipt/:language/:id): the single "Your convention"
// page. The store only carries the language (read by the IntlProvider of the shell).
export const Page = ({ match, actions }) => {
    const language = pageLanguage(match.params.language);
    useEffect(() => {
        actions.setLanguage(language);
    }, [actions, language]);
    return <ConventionPage key={`${match.params.id}:${language}`} ackToken={match.params.id} language={language} />;
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ setLanguage: componentActions.setApplicationLanguage }, dispatch),
});

export default connect(null, mapDispatchToProps)(Page);
